import {BrowserRouter, Routes, Route} from 'react-router-dom'


import Login from '../pages/login'
import Home from '../pages/home'

import AreaAdm from '../components/areas/adm/area-adm'
import CriarAdm from '../components/areas/adm/criar-adm'
import ListarADM from '../components/areas/adm/listar-adm'
import EditarADM from '../components/areas/adm/editar-adm'

import AreaAluno from '../components/areas/aluno/area-aluno'
import CriarAluno from '../components/areas/aluno/criar-aluno'
import ListarAluno from '../components/areas/aluno/listar-aluno'
import EditarAluno from '../components/areas/aluno/editar-aluno'

import AreaEscola from '../components/areas/escola/area-escola'
import CriarEscola from '../components/areas/escola/criar-escola'
import ListarEscola from '../components/areas/escola/listar-escola'
import EditarEscola from '../components/areas/escola/editar-escola'

import AreaFilial from '../components/areas/filial/area-filial'
import CriarFilial from '../components/areas/filial/criar-filial'
import ListarFilial from '../components/areas/filial/listar-filial'
import EditarFilial from '../components/areas/filial/editar-filial'

import AreaPortaria from '../components/areas/portaria/area-portaria'
import CriarPortaria from '../components/areas/portaria/criar-portaria'
import ListarPortaria from '../components/areas/portaria/listar-portaria'
import EditarPortaria from '../components/areas/portaria/editar-portaria'

import AreaResponsavel from '../components/areas/responsavel/area-responsavel'
import CriarResponsavel from '../components/areas/responsavel/criar-responsavel'
import ListarResponsavel from '../components/areas/responsavel/listar-responsavel'
import EditarResponsavel from '../components/areas/responsavel/editar-responsavel'

import AreaResponsavelTemporario from '../components/areas/responsavel-temporario/area-responsavel-temporario'
import CriarResponsavelTemporario from '../components/areas/responsavel-temporario/criar-responsavel-temporario'
import ListarResponsavelTemporario from '../components/areas/responsavel-temporario/listar-responsavel-temporario'
import EditarResponsavelTemporario from '../components/areas/responsavel-temporario/editar-responsavel-temporario'

import AreaResponsaveis from '../components/areas/relacionamento-responsavel/area-relacionamento-responsavel'
import CriarResponsaveis from '../components/areas/relacionamento-responsavel/criar-relacionamento-responsavel'
import ListarResponsaveis from '../components/areas/relacionamento-responsavel/listar-relacionamento-responsavel'
import EditarResponsaveis from '../components/areas/relacionamento-responsavel/editar-relacionamento-responsavel'

import AreaTurma from '../components/areas/turma/area-turma'
import CriarTurma from '../components/areas/turma/criar-turma'
import ListarTurma from '../components/areas/turma/listar-turma'
import EditarTurma from '../components/areas/turma/editar-turma'

import AreaCheckin from '../components/areas/checkin/area-checkin'
import CriarCheckin from '../components/areas/checkin/criar-checkin'
import CriarCheckinDistancia from '../components/areas/checkin/criar-checkin-distancia'
import ListarCheckin from '../components/areas/checkin/listar-checkin'


import { RouteADM } from './routeADM'
import { RouteAluno } from './routeAluno'
import { RouteFilial } from './routeFilial'
import { RouteTurma } from './routeTurma'
import { RouteCheckin } from './routeCheckin'
import { PrivateRoute } from './privateRoute'


export function Router(){

    return(
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Login/>}></Route>
                <Route exact path='/home' element={
                    <PrivateRoute>
                        <Home/>
                    </PrivateRoute>
                }></Route>
                <Route exact path='/area-adm' element={
                        <RouteADM>
                            <AreaAdm/>
                        </RouteADM>
                }></Route>
                <Route exact path='/criar-adm' element={
                    <RouteADM>
                        <CriarAdm/>
                    </RouteADM>
                }></Route>
                <Route exact path='/listar-adm' element={
                    <RouteADM>
                        <ListarADM/>
                    </RouteADM>
                }></Route>
                <Route exact path='/editar-adm/:id' element={
                    <RouteADM>
                        <EditarADM/>
                    </RouteADM>
                }></Route>
                <Route exact path='/area-aluno' element={
                    <RouteAluno>
                        <AreaAluno/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/criar-aluno' element={
                    <RouteAluno>
                        <CriarAluno/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/listar-aluno' element={
                    <RouteAluno>
                        <ListarAluno/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/editar-aluno/:id' element={
                    <RouteAluno>
                        <EditarAluno/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/area-escola' element={
                    <RouteADM>
                        <AreaEscola/>
                    </RouteADM>
                }></Route>
                <Route exact path='/criar-escola' element={
                    <RouteADM>
                        <CriarEscola/>
                    </RouteADM>
                }></Route>
                <Route exact path='/listar-escola' element={
                    <RouteADM>
                        <ListarEscola/>
                    </RouteADM>
                }></Route>
                <Route exact path='/editar-escola/:id' element={
                    <RouteADM>
                        <EditarEscola/>
                    </RouteADM>
                }></Route>
                <Route exact path='/area-filial' element={
                    <RouteFilial>
                        <AreaFilial/>
                    </RouteFilial>
                }></Route>
                <Route exact path='/criar-filial' element={
                    <RouteFilial>
                        <CriarFilial/>
                    </RouteFilial>
                }></Route>
                <Route exact path='/listar-filial' element={
                    <RouteFilial>
                        <ListarFilial/>
                    </RouteFilial>
                }></Route>
                <Route exact path='/editar-filial/:id' element={
                    <RouteFilial>
                        <EditarFilial/>
                    </RouteFilial>
                }></Route>
                <Route exact path='/area-portaria' element={
                    <RouteAluno>
                        <AreaPortaria/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/criar-portaria' element={
                    <RouteAluno>
                        <CriarPortaria/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/listar-portaria' element={
                    <RouteAluno>
                        <ListarPortaria/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/editar-portaria/:id' element={
                    <RouteAluno>
                        <EditarPortaria/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/area-responsavel' element={
                    <RouteAluno>
                        <AreaResponsavel/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/criar-responsavel' element={
                    <RouteAluno>
                        <CriarResponsavel/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/listar-responsavel' element={
                    <RouteAluno>
                        <ListarResponsavel/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/editar-responsavel/:cpf' element={
                    <RouteAluno>
                        <EditarResponsavel/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/area-responsavel-temporario' element={
                    <RouteAluno>
                        <AreaResponsavelTemporario/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/criar-responsavel-temporario' element={
                    <RouteAluno>
                        <CriarResponsavelTemporario/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/listar-responsavel-temporario' element={
                    <RouteAluno>
                        <ListarResponsavelTemporario/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/editar-responsavel-temporario/:cpf' element={
                    <RouteAluno>
                        <EditarResponsavelTemporario/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/area-relacionamento-responsavel' element={
                    <RouteAluno>
                        <AreaResponsaveis/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/criar-relacionamento-responsavel' element={
                    <RouteAluno>
                        <CriarResponsaveis/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/listar-relacionamento-responsavel' element={
                    <RouteAluno>
                        <ListarResponsaveis/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/editar-relacionamento-responsavel/:idresponsavel/:ra' element={
                    <RouteAluno>
                        <EditarResponsaveis/>
                    </RouteAluno>
                }></Route>
                <Route exact path='/area-turma' element={
                    <RouteTurma>
                        <AreaTurma/>
                    </RouteTurma>
                }></Route>
                <Route exact path='/criar-turma' element={
                    <RouteTurma>
                        <CriarTurma/>
                    </RouteTurma>
                }></Route>
                <Route exact path='/listar-turma' element={
                    <RouteTurma>
                        <ListarTurma/>
                    </RouteTurma>
                }></Route>
                <Route exact path='/editar-turma/:id' element={
                    <RouteTurma>
                        <EditarTurma/>
                    </RouteTurma>
                }></Route>
                <Route exact path='/area-checkin' element={
                    <RouteCheckin>
                        <AreaCheckin/>
                    </RouteCheckin>
                }></Route>
                <Route exact path='/criar-checkin' element={
                    <RouteCheckin>
                        <CriarCheckin/>
                    </RouteCheckin>
                }></Route>
                <Route exact path='/listar-checkin' element={
                    <RouteCheckin>
                        <ListarCheckin/>
                    </RouteCheckin>
                }></Route>
                <Route exact path='/criar-checkin-distancia' element={
                    <RouteCheckin>
                        <CriarCheckinDistancia/>
                    </RouteCheckin>
                }></Route>
            </Routes>
        </BrowserRouter>
    )

}